import { toast as sonnerToast } from "sonner";
import { ImportantToast, Toast } from "./sonner";

export function toast(title: string, description?: string) {
    return sonnerToast.custom(() => <Toast className="min-w-[320px]" title={title} description={description} />);
}

export function importantToast(title: string, description: string, actionLabel: string, action: () => void) {
    return sonnerToast.custom(() => <ImportantToast title={title} description={description} actionLabel={actionLabel} action={action} />, {
        position: "top-center",
        duration: Infinity,
    });
}

/** Toast with undo functionality */
export function toastWithUndo(title: string, description?: string, onUndo?: (id: string | number) => void) {
    return sonnerToast.custom(
        (id) => <Toast className="min-w-[480px]" title={title} description={description} action={() => onUndo?.(id)} />,
        { duration: 15000 }
    );
}

export function dismissToast(id: string | number) {
    sonnerToast.dismiss(id);
}
